/* global jQuery */

import { isFDA, isCanadian, isLegacyFDA } from "./format.js";

/* figure out label type and select radio button for user */
const setEmbedOptions = () => {
  if (isFDA()) {
    jQuery("#embed_label_format_new_fda").prop("checked", true);
  } else if (isCanadian()) {
    jQuery("#embed_label_format_new_canada").prop("checked", true);
  } else if (isLegacyFDA()) {
    jQuery("#embed_label_format_old_fda").prop("checked", true);
  }
};

// Embed code options logic
const calculateEmbedCode = () => {
  const token = jQuery("#embed-code-token").attr("class");
  const params = {
    label_format: jQuery("input[name='embed_label_format']:checked").val(),
    ingredients: jQuery("#embed_ingredients").is(":checked") ? 1 : 0,
    allergens: jQuery("#embed_allergens").is(":checked") ? 1 : 0,
  };

  const searchParams = new URLSearchParams(Object.entries(params));
  const query = searchParams.toString();
  const url = `https://www.recipal.com/recipes/${token}/embed.js?${query}`;

  const embedCode = `<script src="${url}" type="text/javascript"></script>`;
  jQuery("#embed-code-output").val(embedCode);
  jQuery("#embed-code-output").trigger("select");
};

export const initializeEmbedCode = () => {
  jQuery(document).on("click", ".js-embed-label", () => {
    window.Modal.show("#embed-code-modal");
    setEmbedOptions();
    calculateEmbedCode();
  });

  jQuery('input[name="embed_label_format"], #embed_ingredients, #embed_allergens').on("click", () =>
    calculateEmbedCode()
  );
};
